const situacaoAluno = [
  { text: 'Ativo', value: 1 },
  { text: 'Inativo', value: 2 },
  { text: 'Afastado - Férias', value: 3 },
  { text: 'Afastado - Saúde', value: 4 },
  { text: 'Ativo - Gratuidade', value: 5 },
];

export default situacaoAluno;
